<div class="coming-soon-content">
  <div class="coming-soon-content__inner">
    <div class="coming-soon-ball">
      <fr8bot-ui-particle-sphere />

      <div class="coming-soon-ball__circle">
        <div class="coming-soon-ball__circle-content">
          <div class="coming-soon-ball__circle-content-icon">
            <fr8bot-ui-icon name="on-the-way" [size]="{ width: 200, height: 24 }" />
          </div>

          <span class="coming-soon-ball__circle-content-title">{{
            'common.comingSoon.title' | translate
          }}</span>
          <span class="coming-soon-ball__circle-content-subtitle">{{
            'common.comingSoon.subtitle' | translate
          }}</span>
          <span class="coming-soon-ball__circle-content-description">{{
            'common.comingSoon.description' | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
